<div class="settings-icon">
    <img src="shared-assets/images/general_icons/service_light.svg" alt="service">
</div>